


































import Component from 'vue-class-component'
import Vue from 'vue'
import { Prop } from 'vue-property-decorator'

@Component({
  name: 'respondeco-block',
})
export default class RespondecoBlock extends Vue {
  @Prop({
    default: 2,
    type: Number,
  })
  public readonly headerType!: number
}
